import { ADD_MILESTONE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { IMilestoneData } from './getMilestone';

export interface Response {
    success: boolean;
    error?: string;
}

export default (newMilestone: IMilestoneData): Promise<Response> => {
    return fetchWithRefresh(ADD_MILESTONE, {
        method: 'POST',
        body: JSON.stringify({ newMilestone }),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
